import React, {useState} from "react";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import {makeStyles} from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import AppBar from "../../../Components/AppBar";
import ImagePreview from "./ImagePreview";
import ActionsContainer from "./ActionsContainer";
import ToolbarContainer from "./ToolbarContainer";
import SubHeader from "../../../Components/SubHeader";
import Switch from "@material-ui/core/Switch";
import Box from "@material-ui/core/Box";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import ToolbarContent from "./ToolbarContent";
import {usePriceList} from "../../../../Providers/PriceListProvider";
import {Trans} from "react-i18next";

const useStyles = makeStyles(theme => ({
  mainContainer: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  container: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    width: '100%',
    backgroundColor: 'white',
    height: '148px',
    zIndex: '2'
  },
  actionsContainer: {
    display: 'flex',
    justifyContent: 'space-around'
  },
  quantityContainer: {
    display: 'flex',
    justifyContent: 'center',
    padding: 0,
    margin: 0,
    listStyle: 'none',
    marginBottom: theme.spacing(2),
  },
  quantityButton: {
    width: '64px',
    height: '64px'
  },
  inputQuantity: {
    width: '64px',
    height: '64px',
    border: '2px solid ' + theme.palette.primary.main,
    boxSizing: 'border-box',
    fontSize: '24px',
    textAlign: 'center',
    lineHeight: '64px'
  }
}))

const WhiteBorder = ({setFormat, onCancel, orderLine}) => {
  const classes = useStyles();
  const { getProductByUuid, getNonWhiteBorderAlternativeProduct,
     isWhiteBorderProduct, getWhiteBorderAlternativeProduct  } = usePriceList();
  const [localProduct, setLocalProduct] = useState(() => {
    return getProductByUuid(orderLine.product.uuid);
  })

  const handleChange = () => {
    setLocalProduct((localProduct) => {
      if (isWhiteBorderProduct(localProduct)) {
        return getNonWhiteBorderAlternativeProduct(localProduct);
      }
      else {
        return getWhiteBorderAlternativeProduct(localProduct);
      }
    })
  }

  console.log('Product is', localProduct);

  return <div className={classes.mainContainer}>
    <AppBar disableGutters />

    <SubHeader onClick={onCancel}>Velg kant</SubHeader>

    <ImagePreview orderLine={orderLine} overrideProduct={localProduct}/>

    <ToolbarContainer>
      <ToolbarContent>
        <Box display="flex" justifyContent="center" alignItems="center" height="100%" width="100%">
          <FormControlLabel
            control={<Switch checked={isWhiteBorderProduct(localProduct)} onChange={handleChange} name="whiteBorder" color="primary" />}
            label="Hvit kant"
          />
      </Box>
      </ToolbarContent>
      <ActionsContainer>
        <Button color="primary" onClick={onCancel}><Trans>Cancel</Trans></Button>
        <Button color="primary" onClick={() => setFormat(localProduct, false)}><Trans>Done</Trans></Button>
      </ActionsContainer>
    </ToolbarContainer>
  </div>
}

export default WhiteBorder;